import { render, staticRenderFns } from "./AddDiscount.vue?vue&type=template&id=dc5afc26"
import script from "./AddDiscount.vue?vue&type=script&lang=js"
export * from "./AddDiscount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports